import React from 'react';
import classnames from 'classnames';

import { YoureDoingSomeThingWrong } from '../assets/components';

export function WPGroup({ data, ...rest }) {
  const Tag = `div`;
  const blockClass = `wp-block-group`;

  const blockClasses = classnames(blockClass, {});

  return (
    <>
      <Tag className={blockClasses}>
        <YoureDoingSomeThingWrong tip="block Group doesn't support dynamic contents" />
      </Tag>
    </>
  );
}
